import React, { useMemo, useState } from "react";
import {
  Container,
  Grid,
  Box,
  TextField,
  InputAdornment,
  Card,
  CardContent,
  Divider,
  Button,
  Switch,
  FormControlLabel,
  Chip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
  Typography,
  CssBaseline,
  alpha,
  Autocomplete,
  TableContainer
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AppNavbar from '../../../components/AppNavbar';
import Header from '../../../components/Header';
import SideMenu from '../../../components/SideMenu';
import AppTheme from '../../../shared-theme/AppTheme';
import AlertMessageDialog from "../../../components/Dialogs/alertMessageDialog";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../../dashboard/theme/customizations';
import { fetchClientes } from "../../../utils/generalsFetch";
import { formatIdentification, formatNumberWithCommas } from "../../../utils/generalFunctions";
import { StyledCellHeader } from "../../../components/StyledCellHeader";
import AccessDeniedBox from '../../../components/AccessDeniedBox';
const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};



const formulario = {
    "campos": [
        {
            "id": 2,
            "name": "Cédula / Identificación",
            "type": "ID",
            "options": [],
            "category": "Datos personales",
            "required": true,
            "deletelable": false
        },
        {
            "id": 1,
            "name": "Nombre completo",
            "type": "texto",
            "options": [],
            "category": "Datos personales",
            "required": true,
            "deletelable": false
        },
        {
            "id": 3,
            "name": "Fecha de nacimiento",
            "type": "fecha",
            "options": [],
            "category": "Datos personales",
            "required": true,
            "deletelable": false
        },
        {
            "id": 4,
            "name": "Estado civil",
            "type": "opciones",
            "options": [
                "Soltero",
                "Casado",
                "Divorciado",
                "Viudo"
            ],
            "category": "Datos personales",
            "required": true
        },
        {
            "id": 1753886767728,
            "name": "Celular",
            "type": "numerotel",
            "options": [],
            "category": "Datos personales",
            "required": true,
            "deletelable": false
        },
        {
            "id": 5,
            "name": "Teléfono",
            "type": "numerotel",
            "options": [],
            "category": "Datos personales",
            "required": true,
            "deletelable": true
        },
        {
            "id": 6,
            "name": "Dirección residencial",
            "type": "texto",
            "options": [],
            "category": "Datos personales",
            "required": true,
            "deletelable": false
        },
        {
            "id": 10,
            "name": "Monto solicitado",
            "type": "monto",
            "options": [],
            "category": "Datos del préstamo",
            "required": true,
            "deletelable": false
        },
        {
            "id": 12,
            "name": "Frecuencia de pago",
            "type": "opciones",
            "options": [
                "Diario",
                "Semanal",
                "Quincenal",
                "Mensual"
            ],
            "category": "Datos del préstamo",
            "required": true,
            "deletelable": false
        },
        {
            "id": 11,
            "name": "Plazo del préstamo ",
            "type": "numero",
            "options": [],
            "category": "Datos del préstamo",
            "required": true,
            "deletelable": false
        },
        {
            "id": 13,
            "name": "Interes",
            "type": "numero",
            "options": [],
            "category": "Datos del préstamo",
            "required": true,
            "deletelable": false
        },
        {
            "id": 14,
            "name": "Mora",
            "type": "numero",
            "options": [],
            "category": "Datos del préstamo",
            "required": true,
            "deletelable": false
        }
    ],
    "categorias": [
        {
            "id": 1,
            "name": "Datos personales",
            "deletelable": false
        },
        {
            "id": 3,
            "name": "Datos del préstamo",
            "deletelable": false
        }
    ]
}

function Currency({ value }) {
  const formatted = useMemo(() =>
    new Intl.NumberFormat(undefined, { style: "currency", currency: "USD" }).format(value),
  [value]);
  return <>{formatted}</>;
}


const LoanTransferModule = (props) => {
  const [notify, setNotify] = useState(true);
  const [reason, setReason] = useState("");
  const [clientes, setClientes] = useState([]);
  const [clienteSelected, setClienteSelected] = useState(null);
  const [clienteInputValue, setClienteInputValue] = useState("");
  const [nombreCliente, setNombreCliente] = useState("");
  const [prestamos, setPrestamos] = useState([]);
  const [prestamoSelected, setPrestamoSelected] = useState(null);
  const [prestamoDetalle, setPrestamoDetalle] = useState(null);
  const [atraso, setAtraso] = useState(0);
  const [amortizaciones, setAmortizaciones] = useState([]);
  const [gestionCargosPagados, setGestionCargosPagados] = useState([]);
  const [catalog, setCatalog] = useState([]);
  const [formData, setFormData] = useState({});
  const [solicitud, setSolicitud] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [accessDenied, setAccessDenied] = useState(false);
  // Set mock data on component mount
  React.useEffect(() => {
    fetchClientes({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
        setClientes(data);
      });
  
    fetchPrestamos();
  }, []);

  const fetchPrestamos = async () => {
    // Fetch active loans (prestamos activos) for the current company, similar to crearrecuperaciondialog.js
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/prestamos/activos/${localStorage.getItem('idcompany')}`, {
        headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
    });
    const data = await response.json();
    if(data["error"]!="Acceso denegado"){
      setAccessDenied(false);
      setPrestamos(data);
    }else{
      setAccessDenied(true);
    }
  }


  const handlePrestamoChange = async(event, value) => {
    setPrestamoSelected(value);
    setPrestamoDetalle(null);
    setAtraso(0);
    setAmortizaciones([]);
    
    if (!value) return; // Don't fetch if no loan is selected
    
    const prestamoDetalle = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/prestamos/detalles/${value.prestamo_original_id}`,{
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
      }
    })
      .then(response => response.json())
      .then(data => {
        setPrestamoDetalle(data.prestamo);
        setAtraso(data.atraso);
        setAmortizaciones(data.amortizaciones_pendientes || []);
        setGestionCargosPagados(data.gestion_cargos_pagados || []);
        setSolicitud(data.solicitud || null);
      })
      .catch(error => {
        console.error('Error fetching prestamo detalle:', error);
        // Clear data on error
        setPrestamoDetalle(null);
        setAtraso(0);
        setAmortizaciones([]);
        setGestionCargosPagados([]);
      });
      setClientes(clientes.filter(cliente => value.cliente_identificacion !== cliente.identificacion));

      const catalog = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/categorias_cargos/prestamos/${value.producto_financiero_id}?idcompany=${localStorage.getItem('idcompany')}`,{
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      })
      .then(response => response.json())
      .then(data => setCatalog(data))
      .catch(error => console.error('Error fetching catalog:', error));
  };

  const handleClienteChange = (val) => {
    if(val){
      setNombreCliente(JSON.parse(val.campos)?.["1"]);
      setClienteInputValue(val.identificacion);
      // Clear form data when existing client is selected
      setFormData({});
    }
    else{
      setNombreCliente("");
      setClienteInputValue("");
      // Clear form data when no client is selected
      setFormData({});
    }
    setClienteSelected(val);
    
  };

  const handleClienteInputChange = (event, newInputValue, reason) => {
    if (reason === 'input') {
      const formattedValue = formatIdentification(newInputValue);
      setClienteInputValue(formattedValue);
      handleClienteSearch(formattedValue);
    } else if (reason === 'clear') {
      setClienteInputValue('');
      handleClienteSearch('');
    }
  }

  const handleClienteSearch = (val) => {
    var cliente = clientes.find(cliente => cliente.identificacion === val);
    if(cliente) {
      setClienteSelected(cliente);
      setNombreCliente(JSON.parse(cliente.campos)?.["1"]);
      // Clear form data when existing client is found
      setFormData({});
    } else {
      setClienteSelected(null);
      setNombreCliente("");
      // Keep form data when no existing client is found (new client)
    }
  }

  const handleFieldChange = (fieldId, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldId]: value
    }));
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const showAlert = (title, message, severity = "success") => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const renderField = (campo) => {
    // Get the value from clienteSelected based on field ID, or from formData if no existing client
    const getFieldValue = () => {
      if (clienteSelected && clienteSelected.campos) {
        try {
          const campos = JSON.parse(clienteSelected.campos);
          return campos[campo.id.toString()] || "";
        } catch (error) {
          console.error("Error parsing client fields:", error);
          return "";
        }
      } else {
        // Return value from formData for new client
        return formData[campo.id] || "";
      }
    };

    const isEditable = !clienteSelected; // Fields are editable when no existing client is selected

    if (campo.id === 2) {
      // Autocomplete for Cédula / Identificación
      return (
        <Autocomplete
          options={clientes}
          getOptionLabel={(option) => option.identificacion || ""}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={campo.name}
              required={campo.required}
            />
          )}
          onChange={(e, val) => handleClienteChange(val)}
          onInputChange={(e, newInputValue, reason) => {
            handleClienteInputChange(e, newInputValue, reason);
          }}
          inputValue={clienteInputValue}
          value={clienteSelected}
        />
      );
    }

    // Regular TextField for other fields
    return (
      <TextField
        fullWidth
        placeholder={campo.name}
        required={campo.required}
        value={getFieldValue()}
        onChange={(e) => handleFieldChange(campo.id, e.target.value)}
        disabled={!isEditable} // Disable if existing client is selected
        select={campo.type === "opciones"}
        type={
          campo.type === "fecha"
            ? "date"
            : campo.type === "numerotel"
            ? "tel"
            : campo.type === "ID"
            ? "text"
            : "text"
        }
        InputLabelProps={
          campo.type === "fecha"
            ? { shrink: true }
            : undefined
        }
        SelectProps={
          campo.type === "opciones"
            ? { native: true }
            : undefined
        }
      >
        {campo.type === "opciones" &&
        campo.options.map((option, idx) => (
          <option key={idx} value={option}>
            {option}
          </option>
        ))}
      </TextField>
    );
  };

  const validateFields = () => {

    if(!clienteSelected){
    let isValid = true;
    let missingFields = [];

    if (!formulario.campos || !Array.isArray(formulario.campos)) {
      // Si no hay definición de campos, no se puede validar
      return true;
    }
    if(!clienteInputValue){
      isValid = false;
      missingFields.push("Cédula / Identificación");
    }

    formulario.campos.forEach((campo) => {
      if (campo.required && campo.category === "Datos personales" && campo.id !== 2) {
        const value = formData[campo.id];
        // Considera vacío si es undefined, null, string vacío o solo espacios
        if (
          value === undefined ||
          value === null ||
          (typeof value === "string" && value.trim() === "")
        ) {
          isValid = false;
          missingFields.push(campo.name || campo.label || `Campo ${campo.id}`);
        }
      }
    });

    if (!isValid) {
      // Show error message using AlertMessageDialog
      showAlert(
        "Campos Requeridos",
        "Por favor complete los siguientes campos obligatorios:\n" + missingFields.join(", "),
        "error"
      );
    }

    return isValid;
    }
    else{
      return true;
    }
  };

  const handleEnviarTraspaso = async () => {
    if (!validateFields()) {
      return;
    }

    const { cliente_campos, ...prestamoDetalleSinClienteCampos } = prestamoDetalle || {};
    
    var solicitudOriginal = JSON.parse(solicitud["campos"]);
    var clienteId = null;

    if(clienteSelected){
        var clientSelectedJson = JSON.parse(clienteSelected.campos);
        clienteId = clienteSelected.id; 
            
    }
    else{
        var clientSelectedJson = formData;
        var url = `${process.env.REACT_APP_SERVER_URL}/api/clientes`;
        
        formData["2"] = clienteInputValue; 
        var data = {
          "identificacion": clienteInputValue,
          "campos": formData,
          "idcompany": localStorage.getItem('idcompany'),
          "created_by": localStorage.getItem('id')
        }
  
        var response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
          },
          body: JSON.stringify(data)
        });
  
        if (!response.ok) {
          const error = await response.json();
          showAlert(
            "Error al Crear Cliente",
            `Error: ${error.message || 'No se pudo crear el cliente'}`,
            "error"
          );
          return;
        }
        clienteId = (await response.json()).id;
  
    }

    Object.keys(clientSelectedJson).forEach((key) => {
      solicitudOriginal[key] = clientSelectedJson[key];
    });


    var url = `${process.env.REACT_APP_SERVER_URL}/api/traspasos`;
    var data = {
      "idcompany": localStorage.getItem('idcompany'),
      "id_productofinanciero": prestamoSelected.producto_financiero_id,
      "sucursal":prestamoSelected.sucursal_id,
      "estado": "aceptada",
      "campos": solicitudOriginal,
      "created_by": localStorage.getItem('id'),
      "prestamo_id": prestamoSelected.prestamo_original_id,
      "solicitud_id": solicitud.id,
      "cliente_id": prestamoSelected.id_cliente,
      "cliente_id_nuevo": clienteId,
      "motivo": reason,
      "historial": prestamoDetalleSinClienteCampos,
      "id_sucursal": localStorage.getItem('id_sucursal'),
    }
    var response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const error = await response.json();
      showAlert(
        "Error al Realizar Traspaso",
        `Error: ${error.message || 'No se pudo realizar el traspaso'}`,
        "error"
      );
      return;
    }
    
    const responseData = await response.json();
    showAlert(
      "Traspaso Exitoso",
      "El traspaso de préstamo se ha realizado correctamente",
      "success"
    );

    reiniciar();
  }

  const reiniciar = () => {
    setClienteSelected(null);
    setClienteInputValue("");
    setFormData({});
    setPrestamoSelected(null);
    setPrestamoDetalle(null);
  }

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header parent={"Gestión Comercial"} child={"Traspaso de Préstamos"} />
            {!accessDenied ? 
            <Container maxWidth={false} sx={{ px: 5, py: 5 }}>
              <Box sx={{ minHeight: '100vh', backgroundColor: '#fff', fontFamily: 'Inter, "Noto Sans", sans-serif' }}>
                <Box maxWidth="lg" mx="auto" py={4}>
                  {/* Header */}
                  <Box display="flex" justifyContent="space-between" alignItems="center" px={2} mb={2}>
                    <Typography variant="h4" fontWeight="bold">
                      Traspaso de Préstamos
                    </Typography>
                  </Box>

                  {/* Grid container layout */}
                  <Grid container spacing={3} sx={{ mt: 1 }}>
                    {/* LEFT COLUMN */}
                    <Grid item size={8}>
                      {/* Search Loan */}
                      <Card sx={{ mb: 2 }}>
                        <CardContent>
                            
                          <Autocomplete
                            freeSolo
                            fullWidth       
                            size="medium"
                            options={prestamos} 
                            getOptionLabel={(option) => option.loan_id + " - " + option.cliente_nombre + " - " + JSON.parse(option.cliente_campos)["2"] + " - " + (option.producto?option.producto:"")}
                            renderOption={(props, option) => (
                                <li {...props}>
                                  <Typography variant="body1" >{option.loan_id} - {option.cliente_nombre} - {JSON.parse(option.cliente_campos)["2"]}</Typography>
                                  {option.producto && <Chip label={option.producto} size="small" color="primary" sx={{ml:1}}/>}
                                </li>
                              )}
                            onChange={(e, val) => {handlePrestamoChange(e,val)}}
                            value={prestamoSelected}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Buscar por ID de Préstamo, Nombre del Cliente, o ID de Documento"
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SearchIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                        </CardContent>
                      </Card>

                      {/* Loan Information */}
                      {prestamoDetalle && (
                      <Card>
                        <CardContent>
                          <Typography variant="h6" fontWeight={700} gutterBottom textAlign="left">
                            Información del Préstamo
                          </Typography>

                          <Grid container spacing={2} mt={2}>
                            <Grid item size={4}>
                              <Typography variant="body2" color="text.secondary">ID del Préstamo</Typography>
                              <Typography>{prestamoSelected.loan_id}</Typography>
                            </Grid>
                            <Grid item size={4}>
                              <Typography variant="body2" color="text.secondary">Producto del Préstamo</Typography>
                              <Typography>{prestamoSelected.producto_financiero}</Typography>
                            </Grid>
                            <Grid item size={4}>
                              <Typography variant="body2" color="text.secondary">Cliente Actual</Typography>
                              <Typography>{prestamoSelected.cliente_nombre}</Typography>
                            </Grid>
                            <Grid item size={4}>
                              <Typography variant="body2" color="text.secondary">Saldo Pendiente</Typography>
                              <Typography variant="h6" color="primary">{formatNumberWithCommas(parseFloat(prestamoDetalle.capitalPendiente)+parseFloat(prestamoDetalle.interesPendiente)+parseFloat(prestamoDetalle.moraPendiente).toFixed(2))}</Typography>
                            </Grid>
                            <Grid item size={4}>
                              <Typography variant="body2" color="text.secondary">Fecha de Inicio del Préstamo</Typography>
                              <Typography>{prestamoDetalle.created_at}</Typography>
                            </Grid>
                            <Grid item size={4}>
                              <Typography variant="body2" color="text.secondary">Sucursal</Typography>
                              <Typography>{prestamoSelected.sucursal_nombre}</Typography>
                            </Grid>
                          </Grid>
                        </CardContent>

                        <Divider sx={{mt:1,mb:1}} />

                        <Accordion elevation={0} sx={{ boxShadow: "none" }}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography color="primary" fontWeight={600}>Ver Historial de Pagos Pendientes</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Paper variant="outlined" sx={{ width: "100%", overflowX: "auto" }}>
                              <TableContainer component={Paper}>
                                <Table>
                                  <TableHead>
                                    <TableRow>
                                      <StyledCellHeader>Fecha</StyledCellHeader>
                                      <StyledCellHeader sx={{textAlign:"center"}}>No. Cuota</StyledCellHeader>
                                      <StyledCellHeader sx={{textAlign:"center"}}>Valor Cuota</StyledCellHeader>
                                      <StyledCellHeader sx={{textAlign:"center"}}>Mora</StyledCellHeader>
                                      <StyledCellHeader sx={{textAlign:"center"}}>A Pagar</StyledCellHeader>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {amortizaciones.map((amortizacion) => (
                                    <TableRow key={amortizacion.id}>
                                      <StyledCellHeader>{amortizacion.Fecha}</StyledCellHeader>
                                      <StyledCellHeader sx={{textAlign:"center"}}>{amortizacion.nocuota}</StyledCellHeader>
                                      <StyledCellHeader sx={{textAlign:"center"}}>{amortizacion.valor}</StyledCellHeader>
                                      <StyledCellHeader sx={{textAlign:"center"}}>{parseFloat(amortizacion.mora).toFixed(2)}</StyledCellHeader>
                                      <StyledCellHeader sx={{textAlign:"center"}}>{(parseFloat(amortizacion.valor)+parseFloat(amortizacion.mora)).toFixed(2)}</StyledCellHeader>
                                    </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Paper>
                          </AccordionDetails>
                        </Accordion>
                      </Card>
                      )}

                      {/* New Client Selection */}
                      {/* Render fields from formulario in category 'Datos personales' */}
                      {prestamoSelected ?
                      <Card sx={{ mt: 2 }}>
                        <CardContent>
                          <Box >
                          <Typography variant="h6" fontWeight={700} gutterBottom textAlign="left">
                              Datos Personales del Nuevo Cliente
                          </Typography>
                          <Grid container spacing={2}>
                              {formulario.campos
                              .filter((campo) => campo.category === "Datos personales")
                              .map((campo) => (
                                  <Grid item size={4} key={campo.id}>
                                  {renderField(campo)}
                                  </Grid>
                              ))}
                          </Grid>
                          </Box>
                          </CardContent>
                      </Card>
                      :
                      <Card sx={{ mt: 2 }}>
                        <CardContent>
                          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight={120}>
                            <Typography variant="h6" fontWeight={700} gutterBottom color="text.secondary" align="center">
                              Debe seleccionar un préstamo para continuar con el traspaso.
                            </Typography>
                            <Typography variant="body2" color="text.secondary" align="center">
                              Por favor, seleccione un préstamo activo en la parte superior para ingresar los datos del nuevo cliente.
                            </Typography>
                          </Box>
                        </CardContent>
                      </Card>
                      }
                    </Grid>

                    {/* RIGHT COLUMN */}
                    <Grid item size={4}>
                      {/* New Client Selection */}
                      <Card sx={{ mb: 2 }}>
                        <CardContent>
                          <Typography variant="h6" fontWeight={700} gutterBottom>
                            Resumen del Nuevo Cliente
                          </Typography>
                          <Stack spacing={2}>
                            {clienteSelected || clienteInputValue ?
                            <Paper variant="outlined" sx={{ p: 2 }}>
                              <Stack direction="row" spacing={2} alignItems="flex-start">
                                <Box sx={{ flexGrow: 1 }}>
                                  <Typography fontWeight={700}>{nombreCliente || formData["1"]}</Typography>
                                  <Typography variant="body2" color="text.secondary">{clienteInputValue}</Typography>
                                  <Typography variant="body2" color="text.secondary">{clienteSelected?JSON.parse(clienteSelected.campos)["6"]:formData["6"]}</Typography>
                                </Box>
{/*                                <Chip label={`Crédito ${mockNewClient.credit}`} color="success" variant="outlined" size="small" />*/}
                              </Stack>
                            </Paper>
                            :
                            <Paper variant="outlined" sx={{ p: 2 }}>
                              <Typography variant="body2" color="text.secondary">Debe seleccionar un cliente o ingresar un cliente nuevo para continuar con el traspaso.</Typography>
                            </Paper>
                            }
                          </Stack>
                        </CardContent>
                      </Card>

                      {/* Transfer Settings */}
                      <Card>
                        <CardContent>
                          <Typography variant="h6" fontWeight={700} gutterBottom>
                            Configuración del Traspaso
                          </Typography>
                          <Stack spacing={2}>
                            <TextField
                              placeholder="Agregar motivo del traspaso (opcional)"
                              value={reason}
                              onChange={(e) => setReason(e.target.value)}
                            />
{/*                            <FormControlLabel
                              control={<Switch checked={notify} onChange={(e) => setNotify(e.target.checked)} />}
                              label="Notificar a ambos clientes por email/SMS"
                            />*/}
                          </Stack>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>

                
                </Box>
              </Box>
            </Container>
            :
            <Box>
              <br></br>
              <br></br>
              <br></br>
              <AccessDeniedBox
                title={'Acceso denegado'}
                message={'No tienes permisos para ver esta sección de Traspaso de Préstamos. Contacta a tu administrador para solicitar acceso o verifica tus roles y permisos.'}
              />
            </Box>
            }
            {/* Summary & Confirmation */}
                          
            {!accessDenied ? 
            <Box display={"flex"} flexDirection={"row"} sx={{position: 'fixed', bottom: 0, left: 0, width: '100%', bgcolor: 'white', p: 2, borderTop: '1px solid #eee'}}>
                <Box sx={{mx:"auto",flexDirection:"row",display:"flex",alignItems:"center",justifyContent:"center"}}>
                    <Paper sx={{maxWidth:200,display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 2 }}>
                        <Typography variant="body2" color="text.secondary">Desde Cliente</Typography>
                        <Typography fontWeight={700}>{prestamoSelected?.cliente_nombre}</Typography>
                    </Paper>
                    <ArrowForwardIcon color="disabled" />
                    <Paper sx={{maxWidth:200,display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 2 }}>
                        <Typography variant="body2" color="text.secondary">Hacia Cliente</Typography>
                        <Typography fontWeight={700}>{nombreCliente?nombreCliente:formData["1"]}</Typography>
                    </Paper>
                </Box>
                <Box sx={{  textAlign: 'right', }}>                                  
                    <Button variant="outlined"  sx={{width:200,fontWeight:"bold", marginRight:5, marginTop:2}} onClick={reiniciar}>Cancelar</Button>
                    <Button variant="contained" color="primarybutton" sx={{width:200,fontWeight:"bold", marginRight:5, marginTop:2}} onClick={handleEnviarTraspaso}>Confirmar Traspaso</Button>
                </Box>
                            
            </Box>
            :
            <Box>
            </Box>
            }



          </Stack>
        </Box>
      </Box>

      <AlertMessageDialog
        open={alertOpen}
        setOpen={setAlertOpen}
        handleClose={handleAlertClose}
        title={alertTitle}
        message={alertMessage}
        severity={alertSeverity}
      />
    </AppTheme>
  );
};

export default LoanTransferModule;
